<template>
  <div
    v-if="currentRecord && (isMissingDocuments || isMissingGuarantors || isWaitingPrice)"
    class="folderCard"
  >
    <h5>
      <router-link :to="'/dossiers/' + currentRecord.id + '/reservation'">
        {{ $t('residences.folderCard.folder')}}{{ currentRecord.number }}
      </router-link>
    </h5>
  </div>

  <div
    v-else-if="currentRecord && currentRecord.progress"
    class="folderCard"
  >
    <h5>
      <router-link :to="'/dossiers/' + currentRecord.id + '/reservation'">
        {{ $t('residences.folderCard.folder')}}{{ currentRecord.number }}
      </router-link>
    </h5>
    <div v-if="opened">
      <p>{{ $t('residences.folderCard.created')}}{{ $moment(currentRecord.created_at).format('DD/MM/YYYY') }}</p>
      <p>{{ $t('residences.folderCard.from')}}<span>{{ currentRecord.desired_started_at ? $moment(currentRecord.desired_started_at).format('DD/MM/YYYY') : '?' }}</span>
        {{ $t('residences.folderCard.to')}}
        <span>{{ currentRecord.desired_finished_at ? $moment(currentRecord.desired_finished_at).format('DD/MM/YYYY') : '?' }}</span></p>
    </div>
  </div>

  <div
    v-else
    class="folderCard"
  >
    <h5 v-if="currentRecord">
      <router-link :to="'/dossiers/' + currentRecord.id + '/reservation'">
        {{ $t('residences.folderCard.folder')}}{{ currentRecord.number }}
      </router-link>
    </h5>
    <h5 v-else>{{ $t('residences.folderCard.title')}}</h5>
    <p>{{ currentRecord ? currentRecord.state_label : $t('residences.folderCard.subtitle') }}</p>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "FolderCard",
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord
    }),
    isMissingDocuments() {
      return this.currentRecord.state === 'processing_missing_documents'
    },
    isMissingGuarantors() {
      return this.currentRecord.state === 'processing_missing_guarantors'
    },
    isWaitingPrice() {
      return this.currentRecord.state === 'granted_waiting_price_acceptation'
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.folderCard';

#{$c} {
  padding: 0 10px;

  @include respond-between(xs, lg) {
    padding: 5px 30px;
  }

  @include respond-above(lg) {
    min-width: 175px;
  }

  h5 {
    font-size: 14px;
    font-weight: 600;
    line-height: 36px;
    color: #303133;
    a {
      color: inherit;
    }
  }

  @include respond-above(lg) {
    p,
    h5 {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  p {
    margin: 0;
    line-height: 1.75;

    span {
      color: #303133;
      font-weight: 600;
    }
  }

  p {
    &:nth-child(2) {
      margin-bottom: 4px;
    }
    &:nth-child(3) {
      margin-bottom: 8px;
    }
  }

  &__button {
    position: absolute;
    right: 0;
    margin-right: 10px;
  }
}
</style>